import "../polyfills/promise-with-resolvers";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { AuthProvider } from "../shared/contexts/AuthContext";
import { queryClient } from "../shared/utils/queryClient";

const title = "KARLI – Poloplast Support Assistent";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

const AppWithProviders = () => (
  <QueryClientProvider client={queryClient}>
    <FluentProvider theme={webLightTheme}>
      <AuthProvider>
        <App title={title} />
      </AuthProvider>
    </FluentProvider>
  </QueryClientProvider>
);

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(<AppWithProviders />);
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
